/**
 * Logo — wordmark + locator.
 *
 * Props:
 *   variant: 'white' | 'black' (default 'white')
 *   showLocator: boolean (default true) — appends "Perth, AU" subtitle
 *   className: extra classes for the outer link
 */
export default function Logo({ variant = 'white', showLocator = true, href = '#top', className = '' }) {
  const src = variant === 'white' ? '/logos/artificers-logo-white.png' : '/logos/artificers-logo-black.png';

  return (
    <a
      href={href}
      aria-label="The Artificer's AI home"
      className={`inline-flex items-center gap-3.5 ${className}`}
    >
      <img src={src} alt="The Artificer's AI" className="h-[30px] w-auto block" />
      {/* Locator is a garnish: below sm it collides with the nav CTA, so hide it */}
      {showLocator && (
        <>
          <span aria-hidden="true" className="hidden sm:block w-px h-[18px] bg-current opacity-20" />
          <span className="hidden sm:block font-mono text-mono-xs tracking-[0.16em] font-medium text-ink-200">Perth, AU</span>
        </>
      )}
    </a>
  );
}
